import { Language } from '../language'

export enum UserTypes {
  approver = 'approver',
  requestor = 'requestor',
  unk = 'unk', // unk because "unknown" is a reserved word in typescript
}

export enum ConsentStatus {
  NOT_REQUESTED = 'NOT_REQUESTED',
  REQUEST_SENT = 'REQUEST_SENT',
  APPROVED = 'APPROVED',
  REVOKED = 'REVOKED',
}

export enum FirstPartyPlatformType {
  XBOXLIVE = 'XBOXLIVE',
  PLAYSTATIONNETWORK = 'PLAYSTATIONNETWORK',
}

export type ConsentInfo = {
  status: ConsentStatus
  parentEmail: string | null
  requestDateTime: string | null
  grantedDateTime: string | null
  parentLanguage: Language
}

export type AccountInfo = {
  id: string
  firstPartyPlatformType: FirstPartyPlatformType
  firstPartyPlatformUserID: string
  createdDateTime: string
  givenName: string | null
  consent?: ConsentInfo
}

export type AccountResponseWithConsentDetails = {
  account: AccountInfo & {
    consent: ConsentInfo
  }
}

export type ConsentResponseWithAccountDetails = {
  consent: ConsentInfo & {
    account: AccountInfo
  }
}
